/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

type Props = {
  width?: string;
  height?: string;
  filled?: boolean;
};

/**
 * MUI icon for "Copy" chat action
 */
const CopyIcon = ({ width = '16', height = '16', filled = false }: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 12 14" fill="none">
      {filled ? (
        <path
          d="M4.2 11.2C3.815 11.2 3.48542 11.0629 3.21125 10.7887C2.93708 10.5146 2.8 10.185 2.8 9.8V1.4C2.8 1.015 2.93708 0.685417 3.21125 0.41125C3.48542 0.137083 3.815 0 4.2 0H10.5C10.885 0 11.2146 0.137083 11.4888 0.41125C11.7629 0.685417 11.9 1.015 11.9 1.4V9.8C11.9 10.185 11.7629 10.5146 11.4888 10.7887C11.2146 11.0629 10.885 11.2 10.5 11.2H4.2ZM1.4 14C1.015 14 0.685417 13.8629 0.41125 13.5887C0.137083 13.3146 0 12.985 0 12.6V2.8H1.4V12.6H9.1V14H1.4Z"
          fill="#0F1114"
        />
      ) : (
        <path
          d="M4.2498 11.2C3.8648 11.2 3.53522 11.0629 3.26105 10.7887C2.98689 10.5146 2.8498 10.185 2.8498 9.8V1.4C2.8498 1.015 2.98689 0.685417 3.26105 0.41125C3.53522 0.137083 3.8648 0 4.2498 0H10.5498C10.9348 0 11.2644 0.137083 11.5386 0.41125C11.8127 0.685417 11.9498 1.015 11.9498 1.4V9.8C11.9498 10.185 11.8127 10.5146 11.5386 10.7887C11.2644 11.0629 10.9348 11.2 10.5498 11.2H4.2498ZM4.2498 9.8H10.5498V1.4H4.2498V9.8ZM1.4498 14C1.0648 14 0.735221 13.8629 0.461055 13.5887C0.186888 13.3146 0.0498047 12.985 0.0498047 12.6V2.8H1.4498V12.6H9.14981V14H1.4498Z"
          fill="#0F1114"
        />
      )}
    </svg>
  );
};
export default CopyIcon;
